import { useState } from "react";

const footerCols = [
  { title: "吃瓜频道", links: ["明星绯闻", "综艺名场面", "剧组内幕", "网红塌房", "现场直击"] },
  { title: "关于平台", links: ["吃瓜理念", "内容原则", "追线团队", "站点动态"] },
  { title: "支持与反馈", links: ["常见问题", "爆料入口", "纠错反馈", "商务合作"] },
];

export default function Footer() {
  const [sent, setSent] = useState(false);
  const [formError, setFormError] = useState("");

  const subscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = (fd.get("company_alt") as string) || "";
    if (honeypot.trim()) {
      setSent(true);
      form.reset();
      return;
    }
    fd.delete("company_alt");
    setFormError("");
    try {
      const res = await fetch("https://readdy.ai/api/form/dae01lrep053ijub167g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        /* ignore */
      }
      if (res.ok && parsed?.code === "OK") {
        setSent(true);
        form.reset();
      } else {
        const msg = parsed?.meta?.message || responseText || "订阅失败，请稍后再试";
        setFormError(String(msg));
      }
    } catch {
      setFormError("网络异常，请稍后再试");
    }
  };

  return (
    <footer id="contact" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" }); }}
              className="inline-flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
                <i className="ri-sparkling-2-fill text-lg"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">爆瓜台</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              爆瓜台是一群爱吃瓜的人做的直播爆料平台。我们想做的很简单：
              让每一个好瓜都能被看见，让每一次围观都值得，第一手瓜，随时开看。
            </p>
            <div className="mt-5 flex flex-col gap-2 text-sm text-foreground-600">
              <span className="flex items-center gap-2"><i className="ri-mail-fill text-primary-500"></i> contact@baoguatai.example.com</span>
              <span className="flex items-center gap-2"><i className="ri-time-line text-primary-500"></i> 吃瓜晚报 · 每晚 21:00 准时送达</span>
            </div>
          </div>

          {footerCols.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h3 className="text-sm font-bold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <button onClick={() => document.getElementById("category")?.scrollIntoView({ behavior: "smooth" })}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition whitespace-nowrap">
                      {l}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <h3 className="text-sm font-bold text-foreground-950">订阅吃瓜晚报</h3>
            <p className="mt-4 text-sm text-foreground-600">每天一份精华瓜报，睡前也不错过热梗。</p>
            <form data-readdy-form id="newsletter" onSubmit={subscribe} className="mt-3 flex flex-col gap-2">
              <input
                type="email"
                name="email"
                placeholder="you@example.com"
                aria-label="邮箱"
                autoComplete="email"
                required
                className="w-full rounded-full border border-background-300/70 bg-background-50 px-4 py-2.5 text-sm text-foreground-950 outline-none transition placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="website_alt"
              />
              <button type="submit" className="whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:opacity-90 transition">
                立即订阅
              </button>
            </form>
            {sent && <p className="mt-2 text-xs text-accent-700">已收到，记得查收你的第一份瓜报！</p>}
            {formError && <p className="mt-2 text-xs text-primary-700">{formError}</p>}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-500 sm:flex-row">
          <span>© 2026 爆瓜台 BaoguaTai · 娱乐直播爆料平台</span>
          <span className="flex items-center gap-2"><i className="ri-heart-3-line text-primary-400"></i> 有边界地吃瓜，吃瓜的尽头是快乐</span>
        </div>
      </div>
    </footer>
  );
}